<template>
  <div>
    <!-- background -->
    <div class="fixed h-screen bg-gray-100 w-screen bg-right bg-no-repeat z-0 top-0 bg-background " style="z-index: -1;"></div>

    <!-- topbar -->
    <div class="w-full top-0 fixed" style="z-index: 99 !important;" v-if="isuserloggedin || $route.name != 'e' || $route.name != 'eid' || $route.name != 'my ticket'">
      <div class="bg-green-1000 py-2 w-full" v-if="isuserloggedin || $route.name != 'e' || $route.name != 'eid' || $route.name != 'my ticket'">
        <div class="w-11/12 mx-auto flex" v-if="isuserloggedin || $route.name != 'e' || $route.name != 'eid' || $route.name != 'my ticket'">
          <!-- logo -->
          <div class="sm:flex-none flex-grow" style="cursor: pointer;" @click="navigator()"> <img class="h-9 sm:mx-2 mt-4" src="/img/myle/svg/logo-nav.png" alt="" /></div>
          <!-- navigation options -->
          <div class="sm:flex-grow pt-1 sm:pt-0 sm:flex w-full left-0 sm:relative bg-green-1000  fixed bottom-0" v-if="isuserloggedin">
            <ul v-if="isuserloggedin" class=" flex flex-row list-none gap-0 2xs:gap-x-3 sm:gap-x-4 md:gap-x-8 2xl:gap-x-12 4xl:gap-x-20 w-max mx-auto">
              <li class="relative w-16">
                <router-link :to="'/explore'">
                  <a class="non-active  cursor-pointer transition duration-500 ease-in-out" :href="'/explore'" v-bind:class="{'active': $route.name === 'e' || $route.name === 'ticket' || $route.name == 'add ticket' || $route.name == 'my ticket' }">
                    <img class=" mx-auto " src="/img/myle/svg/ic_NavExplore.svg" alt="">
                    <p class="text-gray-300  text-2xs hidden 2xs:block text-center mb-1 ">EXPLORE</p>
                  </a>
                </router-link>
              </li>

              <li class="relative w-16">
                <router-link :to="'/my-likes'">
                  <a class="non-active cursor-pointer transition duration-500 ease-in-out" :href="'/my-likes'">
                    <img class=" mx-auto  non-active" src="/img/myle/svg/ic_NavActivities.svg" alt="">
                    <p class="text-gray-300 text-2xs hidden 2xs:block text-center mb-1 ">BOOKMARK</p>
                  </a>
                </router-link>
              </li>

              <li class="relative w-16">
                <router-link :to="'/post-event'">
                  <a class="non-active cursor-pointer transition duration-500 ease-in-out" :href="'/post-event'">
                    <img class=" mx-auto" src="/img/myle/svg/ic_NavPostEvent.svg" alt="">
                    <p class="text-gray-300 text-2xs hidden 2xs:block text-center mb-1 ">POST</p>
                  </a>
                </router-link>
              </li>

              <li class="relative w-16" style="pointer-events-none">
                <router-link :to="'/activity'">
                  <a class="non-active cursor-pointer transition duration-500 ease-in-out" :href="'/activity'">
                    <img class=" mx-auto" src="/img/myle/svg/ic_NavMessages.svg" alt="">
                    <p class="text-gray-300 text-2xs hidden 2xs:block text-center mb-1 ">ACTIVITY</p>
                  </a>
                </router-link>
              </li>

              <li class="relative w-16" style="pointer-events-none">
                <router-link :to="'/account'">
                  <a class="non-active cursor-pointer transition duration-500 ease-in-out" :href="'/account'" v-bind:class="{'active': $route.name === 'account'}">
                    <img class="mx-auto" src="/img/myle/svg/ic_NavAccount.svg" alt="">
                    <p class="text-gray-300 text-2xs hidden 2xs:block text-center mb-1 ">ACCOUNT</p>
                  </a>
                </router-link>
              </li>
            </ul>
          </div>

          <!-- -->
          <div v-if="user && user.id" id="user-menu" class="flex-none" @click="clickable">
            <div class="flex mt-2 cursor-pointer transition duration-500 ease-in-out  items-center">
              <div class=" overflow-hidden rounded-full w-10 h-10  border-lime border-2">
                <img class="w-full h-full object-cover" :src="'https://storage.googleapis.com/s8w80ukr9zgzqst5era7u9uh1eo5uf81kibwqdsu6j4f1mh7tw/' + user.profilePicture" alt="" />
              </div>
              <img src="/img/myle/svg/ic_NavDropdown.svg" class="ml-1" alt="" style="width: 0.7rem;" />
            </div>
            <!-- <p class="text-white ml-1 text-xs cursor-pointer transition duration-500 ease-in-out">{{userName}}</p> -->
          </div>

        </div>
      </div>

      <div class="w-11/12 mx-auto relative" @click="clickablediv" v-if="show">
        <div class="w-56  bg-white p-1 absolute z-40 right-2 rounded shadow-box " id="menu-box">
          <div class="flex items-center m-1 pb-2 border-b border-lime">
            <div class="flex-none w-12 h-12">
              <img :src="'https://storage.googleapis.com/s8w80ukr9zgzqst5era7u9uh1eo5uf81kibwqdsu6j4f1mh7tw/' + user.profilePicture" class=" w-full h-full object-cover rounded-full" alt="">
            </div>
            <div class="flex-grow pl-2">
              <p class="text-gray-700 font-bold text-xs">{{ (user && user.fullName) ? user.fullName : 'Guest' }}</p>
              <a class="text-gray-700 font-light text-xs cursor-pointer transition duration-500 ease-in-out  hover:text-lime" @click="warning">See your profile</a>
            </div>
          </div>

          <ul class="w-full border-b pb-1 border-lime">
            <li v-if="false" class="w-full flex cursor-pointer transition duration-500 ease-in-out  items-center p-3 hover:bg-gray-150 rounded " @click="warning">
              <img class="flex-none" src="/img/myle/svg/ic_preferences.svg" alt="">
              <p class="flex-grow px-4 text-gray-500">Preferences</p>
            </li>
            <li v-if="false" class="w-full flex cursor-pointer transition duration-500 ease-in-out  items-center p-3 hover:bg-gray-150 rounded " @click="warning">
              <img class="flex-none" src="/img/myle/svg/ic_preferences.svg" alt="">
              <p class="flex-grow px-4 text-gray-500">Contact us</p>
            </li>
            <li class="w-full flex cursor-pointer transition duration-500 ease-in-out  items-center p-3 hover:bg-gray-150 rounded "  @click="navigatetouser">
              <img class="flex-none" src="/img/myle/svg/ic_logout.svg" alt="">
              <p class="flex-grow px-4 text-gray-500">Profile</p>
            </li>
            <li class="w-full flex cursor-pointer transition duration-500 ease-in-out  items-center p-3 hover:bg-gray-150 rounded "  @click="logoutHandler">
              <img class="flex-none" src="/img/myle/svg/ic_logout.svg" alt="">
              <p class="flex-grow px-4 text-gray-500">Logout</p>
            </li>
          </ul>

          <div class=" w-full text-gray-400 mx-auto px-1">
            <a href="https://myle.com/privacy" id="links" target="_blank" class="hover:text-lime text-xs  font-extralight cursor-pointer transition duration-500 ease-in-out  transition ease-in-out duration-500">Privacy</a> -
            <a href="https://myle.com/terms" id="links" target="_blank" class="hover:text-lime text-xs  font-extralight cursor-pointer transition duration-500 ease-in-out  transition ease-in-out duration-500"> Terms </a> -
            <a href="https://myle.com/cookies" id="links" target="_blank" class="hover:text-lime text-xs  font-extralight cursor-pointer transition duration-500 ease-in-out  transition ease-in-out duration-500"> Cookies </a>
            <a v-if="false" class="hover:text-lime text-xs  font-extralight cursor-pointer transition duration-500 ease-in-out  transition ease-in-out duration-500" @click="warning"> Feedback </a> <br>
            <a class=" cursor-default text-xs  font-extralight"> MYLE &#169 2023 </a>
          </div>
        </div>
      </div>

      <subnavbar v-if="$route.name === 'explore'" />
      <suboptionbar v-if="$route.name === 'my-likes'" />
      <subActivityBar v-if="$route.name === 'activity'" />
      <ticketOptionBar v-if="$route.name === 'ticket' || $route.name === 'account'" />
    </div>


    <!-- topbar -->
    <div class="w-full top-0 fixed " style="z-index: 99 !important;" v-if="!isuserloggedin && ($route.name == 'e' || $route.name == 'my ticket' || $route.name == 'eid')">
      <div class="bg-green-1000 py-2 pb-6 w-full ">
        <div class="w-11/12 mx-auto flex justify-center items-center">
          <!-- logo -->
          <div class="sm:flex-none flex-grow mx-auto" style="cursor: pointer;" @click="navigator()"> <img class="h-9 sm:mx-2 mt-4 mx-auto" src="/img/myle/svg/logo-nav.png" alt="" /></div>
        </div>
      </div>
    </div>

    
  </div>
</template>
<script>
  import router from "@/router";
  import subnavbar from './Subnavbar';
  import suboptionbar from './SubOptionBar';
  import subActivityBar from './SubActivitybar';
  import ticketOptionBar from './ticketOptionBar';

  import { mapActions, mapState } from 'vuex'

  export default {
    name: "topnavbar",
    components: {
      subnavbar,
      suboptionbar,
      subActivityBar,
      ticketOptionBar
    },
    data() {
      return {
        userName: this.$CURRENT_USER.getUserInfo('fullName', 'Guest'),
        profilePic: this.$CURRENT_USER.getProfilePicture(),
      };
    },
    props: {
     show: {
       type: Boolean,
       default: false
     }
    },
    computed: {
      ...mapState("account", ["user"]),
      isuser() {
        console.log(this.$CURRENT_USER.getUserId());
        return this.$CURRENT_USER.getUserId();
      },
      isuserloggedin() {
        console.log(this.$CURRENT_USER.getUserId(), this.$route);
        return this.$CURRENT_USER && this.$CURRENT_USER.getUserId();
      }
    },
    methods: {
      ...mapActions('account', ['logout']),
      ...mapActions("events", [
        "getCategories",
      ]),
      navigatetouser() {
        router.push({
          name: 'user',
          params: {id: this.$CURRENT_USER.getUserId()}
        });
      },
      logoutHandler() {
        this.logout();
        router.push("/login");
      },
      clickable(event) {
        if (!this.user || !this.user.id) {
          return;
        }
        event.stopPropagation();
        event.preventDefault();
        this.show=true;
        this.$emit('toggle', this.show);
      },
      clickablediv(event) {
        if (event.target.id != 'links') {
          event.stopPropagation();
          event.preventDefault();
        }
      },
      navigator() {
        this.$router.push({ name: "explore" });
      },
      warning() {
        this.$toast.warning("Feature will be coming soon", { timeout: 4000 });
      }
    },
    mounted() {
      this.getCategories()
    }
  };
</script>
<style>
  .rit-0 {
    right: 0 !important;
  }
</style>
